export default Object.freeze({
    DEFAULT_VUE_APP_APM_ACTIVE: true,
    DEFAULT_VUE_APM_SERVICE_NAME: 'crm-front',
    DEFAULT_VUE_APP_VERSION: require('../../package.json').version,
    DEFAULT_VUE_APP_APM_SERVER_URL: 'https://rm.fix-price.com',
    DEFAULT_VUE_APP_APM_SERVER_PREFIX: '',
    DEFAULT_VUE_APP_APM_ENVIRONMENT: 'test',
});